<template>
  <div id="app">
    <headerView :seletedindex="seletedindex" />
    <div class="hero">
      <div class="hero-content">
        <h1>{{courseBanner.title}}</h1>
        <p>{{courseBanner.subTitle}}</p>
      </div>
      <div class="hero-image">
        <img :src="courseBanner.imgUrl" draggable="false" />
      </div>
    </div>

    <div class="course-section">
      <h2 class="section-title">精选课程体系</h2>
      <div class="course-grid">
        <div class="course-card" v-for="(item,index) in courseList" :key="index">
          <div
            class="course-image"
            :style="{ backgroundImage:'url('+item.imgUrl+')'}"
            alt="WeDo 2.0 robot with blue light"
          ></div>
          <div class="course-content">
            <span class="course-tag">{{item.difficulty}}</span>
            <span class="course-duration">{{item.week}}周</span>
            <h3 class="course-title">{{item.title}}</h3>
            <p class="course-description">{{item.subName}}</p>
            <div>
              <el-rate
                v-if="item.rating > 0"
                v-model="item.rating"
                disabled
                show-score
                text-color="#ff9900"
                :max="5"
              ></el-rate>
            </div>
            <!-- <div class="course-price">¥{{item.price}}</div> -->
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        class="pagination"
      ></el-pagination>

      <h2 class="section-title">我们的优势</h2>
      <div class="features">
        <div class="feature-item">
          <i class="icon iconfont icon-zaixianxuexi"></i>
          <h3 class="feature-title">实践学习</h3>
          <p class="feature-description">通过动手操作自主领悟，提升实战能力</p>
        </div>
        <div class="feature-item">
          <i class="icon iconfont icon-jiaoxueguanli"></i>
          <h3 class="feature-title">专业讲师</h3>
          <p class="feature-description">业内资深专家一对一指导，保证学习质量</p>
        </div>
        <div class="feature-item">
          <i class="icon iconfont icon-shijian"></i>
          <h3 class="feature-title">灵活学习</h3>
          <p class="feature-description">自定进度，随时随地开始您的学习之旅</p>
        </div>
      </div>
    </div>
    <footerView></footerView>
  </div>
</template>

<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import { homeBanner, getcourses, getCourseType } from "@/api/index";
export default {
  components: { headerView, footerView },
  data() {
    return {
      seletedindex: 3,
      total: 0,
      pageIndex: 1,
      pageSize: 6,
      courseBanner: {
        title: "",
        subTitle: "",
        imgUrl: ""
      },
      courseList: [],
      courseType: []
    };
  },
  created() {
    this.$nextTick(async () => {
      await this.getcourseBanner();
      await this.getCourseTypeList();
      await this.getcoursesList();
    });
  },
  methods: {
    handleCurrentChange(index) {
      this.pageIndex = index;
      this.getcoursesList();
    },
    async getCourseTypeList() {
      const resType = await getCourseType("/api/zaoying/courseCategories");
      if (resType && resType.length > 0) {
        this.courseType = resType;
      }
      // if (res.length > 0) {
      // }
    },
    async getcourseBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 7 });
      if (res.length > 0) {
        this.courseBanner = res[0];
      }
    },
    async getcoursesList() {
      const res = await getcourses("/api/zaoying/courses", {
        category_id: 93,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize
      });
      if (res) {
        this.courseList = [
          ...res.items.map(item => {
            return {
              difficulty: this.getDifficultyTitle(item.difficulty),
              id: item.id,
              price: item.price,
              rating: parseFloat(item.rating),
              subName: item.subName,
              title: item.title,
              week: item.week,
              imgUrl: item.imgUrl
            };
          })
        ];
      }
      this.total = res.TotalRecords;
    },
    getDifficultyTitle(difficulty) {
      const matchedItem = this.courseType.find(
        item => item.id === parseInt(difficulty)
      );
      return matchedItem ? matchedItem.title : "";
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Noto Sans SC", sans-serif;
}

body {
  background: #fff;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10%;
  background: white;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #333;
}

.logo img {
  height: 40px;
  margin-right: 10px;
}

nav a {
  margin-left: 30px;
  text-decoration: none;
  color: #333;
}

.hero {
  padding: 50px 10%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hero-content {
  flex: 1;
}

.hero-content h1 {
  font-size: 36px;
  margin-bottom: 20px;
}

.hero-content p {
  font-size: 18px;
  color: #666;
}

.hero-image {
  flex: 1;
  text-align: right;
}

.hero-image img {
  max-width: 80%;
  border-radius: 10px;
}

.course-section {
  padding: 50px 10%;
}

.section-title {
  margin-top: 30px;
  font-size: 24px;
  margin-bottom: 30px;
  text-align: center;
}

.course-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 50px;
}

.course-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.course-image {
  height: 200px;
  background-size: cover;
  background-position: center;
}

.course-content {
  padding: 20px;
}

.course-tag {
  background: #f0f7ff;
  color: #3478f6;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 14px;
  display: inline-block;
}

.course-duration {
  color: #666;
  font-size: 14px;
  margin-left: 10px;
}

.course-title {
  margin: 10px 0;
  font-size: 18px;
}

.course-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}

/* .course-rating {
  color: #ffd700;
} */

.course-price {
  color: #3478f6;
  font-size: 20px;
  font-weight: bold;
}

.features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  padding: 0 10%;
  text-align: center;
}

.feature-item {
  padding: 30px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 40px;
  color: #3478f6;
  margin-bottom: 20px;
}

.feature-title {
  font-size: 18px;
  margin-bottom: 10px;
}

.feature-description {
  color: #666;
  font-size: 14px;
}

footer {
  background: #1a1f2e;
  color: white;
  padding: 50px 10% 20px;
  margin-top: 50px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-bottom: 30px;
}

.footer-section h3 {
  margin-bottom: 20px;
}

.footer-section p,
.footer-section a {
  color: #999;
  text-decoration: none;
  display: block;
  margin-bottom: 10px;
}

.copyright {
  text-align: center;
  color: #666;
  padding-top: 20px;
  border-top: 1px solid #333;
}

.pagination {
  text-align: center;
}
</style>